var _rect, _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 10,
    fill: "#016DE6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_8827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 20.8333C15.766 20.8343 16.5249 20.6839 17.2327 20.3906C17.9406 20.0974 18.5835 19.6672 19.1246 19.1247C19.6671 18.5836 20.0973 17.9407 20.3905 17.2328C20.6837 16.525 20.8342 15.7662 20.8332 15C20.8342 14.2338 20.6837 13.475 20.3905 12.7671C20.0973 12.0592 19.6671 11.4163 19.1246 10.8752C18.5835 10.3327 17.9406 9.90251 17.2327 9.60929C16.5249 9.31607 15.766 9.16564 14.9998 9.16663C14.2337 9.16565 13.4748 9.3161 12.767 9.60931C12.0591 9.90253 11.4162 10.3327 10.8751 10.8752C10.3326 11.4163 9.9024 12.0592 9.60919 12.7671C9.31597 13.475 9.16553 14.2338 9.16651 15C9.16552 15.7662 9.31595 16.525 9.60917 17.2328C9.90238 17.9407 10.3326 18.5836 10.8751 19.1247C11.4162 19.6672 12.0591 20.0974 12.767 20.3906C13.4748 20.6838 14.2337 20.8343 14.9998 20.8333Z",
    stroke: "#016DE6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9997 11.2083C15.1931 11.2083 15.3785 11.2851 15.5153 11.4218C15.652 11.5586 15.7288 11.744 15.7288 11.9374C15.7288 12.1308 15.652 12.3163 15.5153 12.453C15.3785 12.5898 15.1931 12.6666 14.9997 12.6666C14.8063 12.6666 14.6208 12.5898 14.4841 12.453C14.3473 12.3163 14.2705 12.1308 14.2705 11.9374C14.2705 11.744 14.3473 11.5586 14.4841 11.4218C14.6208 11.2851 14.8063 11.2083 14.9997 11.2083Z",
    fill: "#016DE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1458 17.9166V13.8333H14.5625M14.125 17.9166H16.1667",
    stroke: "#016DE6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_8827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastInfo);
export default __webpack_public_path__ + "static/media/toast-info.1db506542af22219c1a294c7c5bc781f.svg";
export { ForwardRef as ReactComponent };